import { isTelemetryEnabled } from '../utils/getTelemetrySwitch';
import { pageTrackingEvent } from './gtm-telemetry';

interface ICaptureEvent {
  event_label?: string | null;
  event_action: string;
  event_category?: string;
  [rest: string]: any;
}

function captureEvent({
  event_label = null,
  event_action = '',
  event_category = 'Conversation',
  ...rest
}: ICaptureEvent) {
  if (!isTelemetryEnabled()) return false;
  pageTrackingEvent({
    event_category: event_category,
    event_action: event_action,
    event_label: event_label,
    event_timestamp: new Date().valueOf().toString(),
    ...rest,
  });
}

export default captureEvent;
